@if (tabManager.isPrimaryTab()) {
  <app-app-update-toast></app-app-update-toast>
  <router-outlet></router-outlet>
  @if (showInstallPrompt) {
    <aside class="install-prompt" role="dialog" aria-label="Instalar Mi Back Office" aria-live="polite">
      <button type="button" class="install-prompt__close" aria-label="Cerrar invitación" (click)="dismissInstallPrompt()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      <i class="pi pi-mobile install-prompt__icon" aria-hidden="true"></i>
      <div class="install-prompt__content">
        @if (isIOSDevice) {
          <p><strong>Instala Mi Back Office</strong><br>Toca <strong>Compartir</strong> y luego <strong>Agregar a pantalla de inicio</strong>.</p>
        } @else if (canInstall) {
          <p><strong>Instala Mi Back Office</strong><br>Accede más rápido y úsala como cualquier otra aplicación.</p>
        }
        <small class="install-prompt__countdown">Se ocultará en {{ installPromptSeconds() }} s</small>
      </div>
      <div class="install-prompt__actions">
        @if (canInstall) {
          <button pButton type="button" icon="pi pi-download" label="Instalar" (click)="installApp()"></button>
        }
        <button
          pButton
          type="button"
          severity="secondary"
          label="Recordarme luego (7 días)"
          (click)="remindInstallLater()">
        </button>
      </div>
    </aside>
  }
  <app-command-palette />
  @if (screenLock.locked()) {
    <!-- Overlay que bloquea -->
    <div class="screen-overlay-lock"></div>
    <!-- Modal de login para autorizaciones -->
    <app-login-modal-autorice
      [style.background-image]="'url(' + theme().background + ')'"
      [style]="{'background-repeat': 'no-repeat','background-size': 'cover', 'background-position': 'top'}">
    </app-login-modal-autorice>
  }
  <app-idle-modal />
  <app-loading></app-loading>
  @if (network?.status() === 'offline') {
    <div class="offline-banner show">
      <i class="pi pi-wifi"></i>
      <span>Sin conexión a internet</span>
    </div>
  }
  @if (network?.status() === 'server-down' && network?.mostrarAvisoServidorNoDisponible()) {
    <div class="offline-banner show">
      <i class="pi pi-server"></i>
      <span>Servidor no disponible</span>
    </div>
  }
  @if (network?.status() === 'local-network-denied') {
    <div class="offline-banner show">
      <i class="pi pi-lock"></i>
      <span>Permisos de red local inhabilitados</span>
    </div>
  }
} @else if (tabManager.isResolving() || tabManager.isReloadRecovery()) {
  <div class="single-tab-pending">
    <app-loading [force]="true" forceText="Preparando sesión..."></app-loading>
  </div>
} @else if (tabManager.isBlocked() && !tabManager.primaryTabId()) {
  <div class="single-tab-pending">
    <app-loading [force]="true" forceText="Recuperando sesión..."></app-loading>
  </div>
} @else if (!tabManager.isSupported() || (tabManager.isBlocked() && tabManager.primaryTabId())) {
  <main class="single-tab-overlay" role="alert" aria-live="assertive">
    <section class="single-tab-card">
      @if (!tabManager.isSupported()) {
        <i class="pi pi-exclamation-triangle single-tab-icon" aria-hidden="true"></i>
        <h1>Navegador no compatible</h1>
        <p>
          Mi Back Office no puede garantizar una sesión segura de una sola pestaña en este navegador.
          Actualiza el navegador o utiliza una versión reciente de Chrome, Edge, Firefox o Safari.
        </p>
      } @else if (tabManager.isBlocked() && tabManager.primaryTabId()) {
        <i class="pi pi-exclamation-triangle single-tab-icon" aria-hidden="true"></i>
        <h1>Mi Back Office ya está abierto en otra pestaña</h1>
        <p>Por seguridad, solo se permite una sesión activa por navegador.</p>
<!--        <button-->
<!--          pButton-->
<!--          type="button"-->
<!--          icon="pi pi-times"-->
<!--          label="Cerrar esta pestaña"-->
<!--          (click)="tabManager.closeCurrentTab()">-->
<!--        </button>-->
      }
    </section>
  </main>
}
